import { createSearchParams, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import dayjs from "dayjs";

// Components
import WelcomeBonusCard from "components/organisms/WelcomeBonusCard";

// Constants
import { GET_PARAMS, GET_POPUP_TYPES } from "constants/popupConfig";

// Hooks
import { useGTM } from "hooks/useGTM";

// Selectors
// eslint-disable-next-line import/no-duplicates
import * as userSelectors from "redux/user/selectors";
import { TABLE_LIST } from "../../constants/navigation/info";
// eslint-disable-next-line import/no-duplicates
import * as userSelector from "../../redux/user/selectors";

// Types
import { BonusType } from "../../types/info";

const WelcomeBonusCardContainer = () => {
  const [timerActive, setTimerActive] = useState(false);
  const navigate = useNavigate();
  const expireDate = useSelector(userSelectors.welcomeExtraBonusExpire);
  const sumDeposit = useSelector(userSelectors.sumDeposit);
  const dateNow = dayjs();
  const dateExtraBonusEnd = dayjs(expireDate);
  const currency = useSelector(userSelector.currency);

  const GTM = useGTM();
  const [bonusData, setBonusData] = useState<BonusType>(TABLE_LIST[0]);

  const getBonus = () => {
    GTM.clickGetWelcomeBonusAccept();
    GTM.openDeposit();
    navigate({
      search: `?${createSearchParams({ [GET_PARAMS.POPUP]: GET_POPUP_TYPES.popup.deposit })}`,
    });
  };

  // eslint-disable-next-line consistent-return
  useEffect(() => {
    if (sumDeposit > 0 || dateNow >= dateExtraBonusEnd) {
      setTimerActive(false);
    }
    if (sumDeposit === 0 && dateNow < dateExtraBonusEnd) {
      const extraBonusInterval = setInterval(() => {
        if (dateNow >= dateExtraBonusEnd) {
          setTimerActive(false);
          clearInterval(extraBonusInterval);
        } else {
          setTimerActive(true);
        }
      }, 1000);
      setTimerActive(false);
      return () => {
        clearInterval(extraBonusInterval);
      };
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sumDeposit, expireDate]);

  useEffect(() => {
    const isCurrency = TABLE_LIST.find(
      (item) => currency && item.currency === currency.isoCode,
    );
    setBonusData(isCurrency || TABLE_LIST[0]);
  }, [currency]);

  return (
    <WelcomeBonusCard
      expireDate={expireDate}
      isActive={timerActive}
      sumDeposit={sumDeposit}
      getBonus={getBonus}
      bonusData={bonusData}
    />
  );
};

export default WelcomeBonusCardContainer;
